import React from 'react';

export interface FaIconProps {
  /** Font Awesome 4 icon name without the `fa-` prefix */
  icon: string;
  className?: string;
}

/** Font Awesome 4 icon wrapper (loaded via CDN in index.html). */
export const FaIcon: React.FC<FaIconProps> = ({ icon, className = '' }) => (
  <i className={`fa fa-${icon} footer-fa-icon ${className}`.trim()} aria-hidden />
);

export const FooterLinkArrow: React.FC = () => (
  <FaIcon icon="chevron-right" className="fp-link-arrow" />
);

interface RatingStarsProps {
  rating: number;
  className?: string;
}

export const FooterRatingStars: React.FC<RatingStarsProps> = ({ rating, className = '' }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.25 && rating - full < 0.75;
  const empty = 5 - full - (half ? 1 : 0);

  return (
    <span className={`footer-rating-stars ${className}`.trim()} aria-hidden>
      {Array.from({ length: full }, (_, i) => (
        <FaIcon key={`full-${i}`} icon="star" className="footer-rating-star footer-rating-star--full" />
      ))}
      {half && <FaIcon icon="star-half-o" className="footer-rating-star footer-rating-star--half" />}
      {Array.from({ length: empty }, (_, i) => (
        <FaIcon key={`empty-${i}`} icon="star-o" className="footer-rating-star footer-rating-star--empty" />
      ))}
    </span>
  );
};
